<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="名称">
              <el-input v-model="searchForm.name" clearable placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addStudyTem">添加学习任务</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="studyList"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="学习任务名称"
                    align="left"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    width="270"
                    label="截止日期"
                    align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.starttime!=0&&scope.row.endtime!=0">{{scope.row.starttime}}至{{scope.row.endtime}}</div>
                      <div v-if="scope.row.starttime==0&&scope.row.endtime==0">不限</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="添加时间"
                    align="center"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="学习模式"
                    align="center"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.mode === 1" size="mini" type="danger">正常模式</el-tag>
                      <el-tag v-if="scope.row.mode === 2" size="mini">闯关模式</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="指派类型"
                    align="center"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.assign===0" :disable-transitions="true" size="mini" type="info">不指派</el-tag>
                      <el-tag v-if="scope.row.assign===1" :disable-transitions="true" size="mini">全员</el-tag>
                      <el-tag v-if="scope.row.assign===2" :disable-transitions="true" size="mini" type="danger">指定人员</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="指派人"
                    align="center"
                    width="100"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="完成标准"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #67C23A;font-weight: bold;">{{scope.row.qualified}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="应学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #f56c6c;font-weight: bold;margin-left: 10px"><i class="el-icon-user-solid"></i> {{ scope.row.should }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #67C23A;font-weight: bold;margin-left: 10px"><i class="el-icon-success"></i> {{ scope.row.pass }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="300">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="editStudyTem(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteStudyTem(scope.row)">删除</el-button>
                      <el-button icon="el-icon-document" size="mini" @click="row=scope.row;showStudy(scope.row)">详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :loading="dialogLoading">
      <el-row>
        <el-col :span="16">
          <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="100px" size="small">
            <el-form-item label="任务名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入培训名称" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="有效期" prop="timeType">
              <el-radio v-model="addForm.timeType" :label="1">
                <el-date-picker
                  v-if="addForm.timeType===1"
                  v-model="addForm.timeArray"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <el-date-picker
                  v-if="addForm.timeType===0"
                  v-model="addForm.timeArray"
                  type="daterange"
                  format="yyyy-MM-dd"
                  disabled
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-radio>
              <el-radio v-model="addForm.timeType" :label="0">无期限</el-radio>
            </el-form-item>
            <el-form-item label="学习模式" prop="mode">
              <el-radio v-model="addForm.mode" :label="2">闯关模式</el-radio>
              <el-radio v-model="addForm.mode" :label="1">正常模式</el-radio>
              <el-tag>闯关模式：学员必须按照阶段顺序学习</el-tag>
            </el-form-item>
            <el-form-item label="指派类型" prop="assign">
              <el-radio v-model="addForm.assign" :label="0">不指派</el-radio>
              <el-radio v-model="addForm.assign" :label="1">全员</el-radio>
              <el-radio v-model="addForm.assign" :label="2">指定人员</el-radio>
            </el-form-item>
            <el-form-item v-if="addForm.assign===2" label="指定人员" prop="dealerIdList">
              <el-select v-model="addForm.dealerIdList" clearable multiple style="width: 100%" placeholder="请选择">
                <el-option
                  v-for="item in dealerList"
                  :key="item.userid"
                  :label="item.name"
                  :value="item.userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-col :span="14">
                <el-form-item label="完成标准" prop="qualified">
                  <el-input v-model="addForm.qualified" clearable show-word-limit>
                    <template slot="append">%(总学习进度达到标准视为学习任务完成)</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="阶段任务" prop="studyStageForm">
              <el-form-item
                v-for="(studyStage,index) in addForm.studyStageForm"
                v-model="addForm.studyStageForm[index]"
                :label="'阶段' + (index + 1)">
                <el-row class="tcf-row">
                  <el-col class="card">
                    <div class="card-body">
                      <el-row>
                        <el-col :span="1">
                          <span style="color: #4b9af8"><i class="el-icon-delete" @click="deleteStage(index)"></i></span>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item :prop="'studyStageForm.'+index+'.name'" :rules="{required: true, message: '请输入阶段任务名称', trigger: 'blur'}"  style="margin-right: 20px">
                            <el-input v-model="studyStage.name" placeholder="请输入阶段任务名称" clearable maxlength="20" show-word-limit/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="15">
                          <el-button size="mini" icon="el-icon-plus" @click="num=index;course.courseVisible=true">课程</el-button>
                          <el-button size="mini" icon="el-icon-plus" @click="num=index;paper.paperVisible=true">试卷</el-button>
                          <el-button size="mini" icon="el-icon-plus" @click="num=index;research.researchVisible=true">问卷</el-button>
                          <el-button size="mini" icon="el-icon-plus" @click="num=index;train.trainVisible=true">线下培训</el-button>
                        </el-col>
                      </el-row>
                      <draggable
                        :list="studyStage.studyStageItemForm"
                        @change="handleDraggableFormItemChange">
                        <div
                          v-for="(item,index2) in studyStage.studyStageItemForm"
                          :key="index2"
                          :style="index2===0?'border: 2px solid #F5F5F5':'border: 2px solid #F5F5F5;border-top: none'">
                          <span v-if="item.type === 1">
                            <el-tag type="success"><i class="el-icon-video-play" style="margin-right: 3px"></i>课程</el-tag>
                            <span style="margin-left: 20px;margin-right: 100px;font-size: 13px;font-weight: bold">{{ item.name }}</span>
                            <span style="color: #4b9af8;float: right;margin-right: 20px"><i class="el-icon-delete" @click="deleteStageItem(index, index2)"></i></span>
                          </span>
                          <span v-if="item.type === 2" @drag="item.xuhao=index2+1">
                            <el-tag type="warning"><i class="el-icon-tickets" style="margin-right: 3px"></i>试卷</el-tag>
                            <span style="margin-left: 20px;margin-right: 100px;font-size: 13px;font-weight: bold">{{ item.name }}</span>
                            <span style="color: #4b9af8;float: right;margin-right: 20px"><i class="el-icon-delete" @click="deleteStageItem(index, index2)"></i></span>
                          </span>
                          <span v-if="item.type === 3" @drag="item.xuhao=index2+1">
                            <el-tag type="danger"><i class="el-icon-document-copy" style="margin-right: 3px"></i>问卷</el-tag>
                            <span style="margin-left: 20px;margin-right: 100px;font-size: 13px;font-weight: bold">{{ item.name }}</span>
                            <span style="color: #4b9af8;float: right;margin-right: 20px"><i class="el-icon-delete" @click="deleteStageItem(index, index2)"></i></span>
                          </span>
                          <span v-if="item.type === 4" @drag="item.xuhao=index2+1">
                            <el-tag><i class="el-icon-place" style="margin-right: 3px;color: #8D55F9"></i>培训</el-tag>
                            <span style="margin-left: 20px;margin-right: 100px;font-size: 13px;font-weight: bold">{{ item.name }}</span>
                            <span style="color: #4b9af8;float: right;margin-right: 20px"><i class="el-icon-delete" @click="deleteStageItem(index, index2)"></i></span>
                          </span>
                        </div>
                      </draggable>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <el-card style="width: calc(30% - 50px);position:fixed;top:24vh;right: calc(5% + 40px);font-size: 13px">
            <div align="center">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addStage">添加阶段</el-button>
              <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="btnLoading" @click="submitTem">提交</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="课程"
      :visible.sync="course.courseVisible"
      width="80%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :loading="course.loading">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" :model="course.searchForm" @submit.native.prevent>
              <el-form-item label="一级类别">
                <el-select v-model="course.searchForm.oneid" clearable style="width: 120px" @change="getTwoClass">
                  <el-option v-for="one in course.courseClass" :label="one.dName" :value="one.dOneid">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级类别">
                <el-select :key="course.twokey" v-model="course.searchForm.twoid" clearable style="width: 180px">
                  <el-option v-for="two in course.twoClass" :label="two.dName" :value="two.dTwoid">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索关键字">
                <el-input v-model="course.searchForm.search" placeholder="请输入关键字" @keyup.enter.native="courseSearch"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="courseSearch">搜索</el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button icon="el-icon-plus" type="primary" @click="addCourse(num)">选择</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col v-loading="course.loading" :span="24">
                <el-table
                  :data="course.kcglcourseData"
                  stripestyle="width: 100%"
                  @selection-change="courseSelect">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    label="#"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-image
                        class="img"
                        :src="scope.row.img_url"
                        :preview-src-list="[scope.row.img_url]"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="课程名称"
                    min-width="400"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div style="font-weight: 400;">{{ scope.row.cname }}</div>
                      <div style="font-size: 12px;color:#909399">
                        <span v-if="scope.row.type===0" style="color:#409EFF"><i class="el-icon-video-play"></i> 视频</span>
                        <span v-if="scope.row.type===1" style="color:#E6A23C"><i class="el-icon-headset"></i> 音频</span>
                        <span v-if="scope.row.type===2" style="color:#67C23A"><i class="el-icon-reading"></i> 电子书</span>
                        <span style="margin-left: 10px;font-weight: normal">{{ scope.row.two_name }} / {{ scope.row.three_name }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="课程章节"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.chapter_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="学习人数"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.study_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="评论数量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.comment_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="views"
                    label="浏览量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.views }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="course.total>0"
                  background
                  :current-page="course.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size="course.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="course.total"
                  @size-change="courseHandleSizeChange"
                  @current-change="courseHandleCurrentChange">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="试卷"
      :visible.sync="paper.paperVisible"
      width="80%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :loading="paper.loading">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" :model="paper.searchForm" @submit.native.prevent>
              <el-form-item label="名称">
                <el-input v-model="paper.searchForm.name" placeholder="请输入名称" @keyup.enter.native="paperSearch"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="paperSearch">搜索</el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button icon="el-icon-plus" type="primary" @click="addPaper(num)">选择</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col v-loading="paper.loading" :span="24">
                <el-table
                  :data="paper.paperList"
                  stripe
                  style="width: 100%"
                  @selection-change="paperSelect">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="dName"
                    label="试卷名称"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dRemark"
                    label="试卷说明"
                    min-width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="是否公开"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.dIspub===0">公开</span>
                      <span v-if="scope.row.dIspub===1">仅组织可见</span>
                      <span v-if="scope.row.dIspub===2">仅经销商可见</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="难度"
                    width="200"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#E6A23C;"><i class="el-icon-star-on"></i> {{scope.row.dDifficult}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="出题人"
                    width="100"
                    align="center"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dTime"
                    label="添加时间"
                    width="200"
                    align="center"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="总题数"
                    width="100"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #409eff;font-weight: bold;">{{scope.row.dTotalCount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总分数"
                    align="center"
                    fixed="right"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #f56c6c;font-weight: bold;">{{scope.row.dTotalScore}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="及格线"
                    width="100"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #67C23A;font-weight: bold;">{{scope.row.dPassline}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="paper.total>0"
                  background
                  :current-page="paper.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size="paper.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="paper.total"
                  @size-change="paperHandleSizeChange"
                  @current-change="paperHandleCurrentChange"/>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="问卷"
      :visible.sync="research.researchVisible"
      width="80%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :loading="research.loading">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" :model="research.searchForm" @submit.native.prevent>
              <el-form-item label="名称">
                <el-input v-model="research.searchForm.title" placeholder="请输入名称" @keyup.enter.native="researchSearch"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="researchSearch">搜索</el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button icon="el-icon-plus" type="primary" @click="addResearch(num)">选择</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col v-loading="research.loading" :span="24">
                <el-table
                  :data="research.researchList"
                  stripe
                  style="width: 100%"
                  @selection-change="researchSelect">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="问卷标题"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="desc"
                    label="问卷说明"
                    min-width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="是否公开"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.ispub===0">公开</span>
                      <span v-if="scope.row.ispub===1">仅组织可见</span>
                      <span v-if="scope.row.ispub===2">仅经销商可见</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="创建人"
                    width="100"
                    align="center"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="time"
                    label="添加时间"
                    width="200"
                    align="center"
                    show-overflow-tooltip/>
                </el-table>
                <el-pagination
                  v-if="research.total>0"
                  background
                  :current-page="research.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size="research.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="research.total"
                  @size-change="researchHandleSizeChange"
                  @current-change="researchHandleCurrentChange"/>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="线下培训"
      :visible.sync="train.trainVisible"
      width="80%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :loading="train.loading">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" :model="train.searchForm" @submit.native.prevent>
              <el-form-item label="名称">
                <el-input v-model="train.searchForm.name" placeholder="请输入名称" @keyup.enter.native="trainSearch"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="trainSearch">搜索</el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button icon="el-icon-plus" type="primary" @click="addTrain(num)">选择</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col v-loading="train.loading" :span="24">
                <el-table
                  :data="train.trainList"
                  stripe
                  style="width: 100%"
                  @selection-change="trainSelect">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="dName"
                    label="培训名称"
                    align="left"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dAddress"
                    label="培训地址"
                    align="left"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dStarttime"
                    label="起始时间"
                    align="center"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dEndtime"
                    label="截止时间"
                    align="center"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    prop="dTime"
                    label="添加时间"
                    align="center"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="指派类型"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.dAssign===0" :disable-transitions="true" size="mini" type="info">不指派</el-tag>
                      <el-tag v-if="scope.row.dAssign===1" :disable-transitions="true" size="mini">全员</el-tag>
                      <el-tag v-if="scope.row.dAssign===2" :disable-transitions="true" size="mini" type="danger">指定人员</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="应学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #f56c6c;font-weight: bold;margin-left: 10px"><i class="el-icon-user-solid"></i> {{scope.row.dShould}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #67C23A;font-weight: bold;margin-left: 10px"><i class="el-icon-success"></i> {{scope.row.dAlready}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="指派人"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip/>
                </el-table>
                <el-pagination
                  v-if="train.total>0"
                  background
                  :current-page="train.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size="train.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="train.total"
                  @size-change="trainHandleSizeChange"
                  @current-change="trainHandleCurrentChange"/>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="任务详情"
      :visible.sync="showVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" @submit.native.prevent>
              <el-form-item label="姓名">
                <el-input v-model="showForm.name" clearable placeholder="关键字搜索" @keyup.enter.native="showSearch" />
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="showSearch">搜索</el-button>
              </el-form-item>
            </el-form>
            <div class="card-content">
              <el-row>
                <el-col :span="24">
                  <el-table
                    :data="showStudyList"
                    style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="学习用户"
                      width="200"
                      align="center"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      label="学习进度"
                      min-width="100"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.schedule"></el-progress>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="完成日期"
                      width="200"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.full===0" :disable-transitions="true" size="mini" type="danger">待完成</el-tag>
                        <span v-if="scope.row.full===1">{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      width="200">
                      <template slot-scope="scope">
                        <el-button icon="el-icon-search" size="mini" @click="showStudyRecord(scope.row)">查看记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
            <el-pagination
              v-if="showTotal>0"
              background
              :current-page="showCurrentPage"
              :page-sizes="[10, 50, 100]"
              :page-size="showPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="showTotal"
              @size-change="showHandleSizeChange"
              @current-change="showHandleCurrentChange"/>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="学习记录"
      :visible.sync="recordVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row>
        <el-col>
          <div>
            <el-table
              :data="studyRecordList"
              style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    :data="props.row.itemList"
                    style="width: 100%"
                    :show-header="false">
                    <el-table-column
                      width="100"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span v-if="scope.row.type === 1">
                          <el-tag type="success"><i class="el-icon-video-play" style="margin-right: 3px"></i>课程</el-tag>
                        </span>
                        <span v-if="scope.row.type === 2">
                          <el-tag type="warning"><i class="el-icon-video-play" style="margin-right: 3px"></i>试卷</el-tag>
                        </span>
                        <span v-if="scope.row.type === 3">
                          <el-tag type="danger"><i class="el-icon-video-play" style="margin-right: 3px"></i>问卷</el-tag>
                        </span>
                        <span v-if="scope.row.type === 4">
                          <el-tag><i class="el-icon-video-play" style="margin-right: 3px"></i>培训</el-tag>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="study_name"
                      min-width="200"
                      align="left"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      width="200"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span v-if="scope.row.schedule===100">
                          <i class="el-icon-success" style="color: #67C23A"></i>{{ scope.row.time }}
                        </span>
                        <el-tag v-if="scope.row.schedule!==100" type="danger" size="mini">待完成</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="100"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.schedule"></el-progress>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                label="阶段序号"
                prop="xuhao"
                align="center"
                width="200px">
              </el-table-column>
              <el-table-column
                label="阶段名称"
                prop="name"
                align="left"
                min-width="200px">
              </el-table-column>
              <el-table-column
                label="完成进度"
                align="center"
                width="100px">
                <template slot-scope="scope">
                  <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.schedule"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getCourseClass, selectDealerList } from '@/api/work'
import { getCourseList } from '@/api/study/course'
import { getDealerPapers, getDealerResearchList } from '@/api/infoManage'
import {
  addOrEditDealerStudyGxj,
  deleteStudyGxj,
  getDealerStudyAssignData,
  getDealerStudyListGxj,
  getDealerTrainListGxj,
  getShowStudyList, getStudyRecordList,
  getStudyStageById
} from '@/api/train'
import qs from 'qs'
import draggable from 'vuedraggable'

export default {
  name: 'delxxzp',
  components: {
    draggable
  },
  data() {
    const validateQualified = (rule, value, callback) => {
      if (value !== null && value !== '' && value !== undefined) {
        const r = /^\+?[1-9][0-9]*$/ // 正整数
        if (!r.test(value)) {
          callback(new Error('请输入正确的正整数'))
        } else {
          if (parseInt(value) >= 0 && parseInt(value) <= 100) {
            callback()
          } else {
            callback(new Error('请输入0-100之间的正整数'))
          }
        }
      } else {
        callback(new Error('请输入完成标准'))
      }
    }
    return {
      searchForm: {
        name: ''
      },
      key: new Date().getTime().toString(),
      dealerList: [],
      dialogTitle: '',
      loading: false,
      dialogVisible: false,
      dialogLoading: false,
      btnLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      studyList: [],
      rules: {
        name: [{ required: true, message: '请输入培训名称', trigger: 'blur' }],
        timeType: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        mode: [{ required: true, message: '请选择学习模式', trigger: 'change' }],
        dealerIdList: [{ required: true, message: '请选择指派人员', trigger: 'change' }],
        qualified: [{ required: true, validator: validateQualified, trigger: 'blur' }],
        studyStageForm: [{ required: true, trigger: 'change' }]
      },
      addForm: {
        dealerIdList: [],
        stid: 0,
        name: '',
        timeType: 0,
        timeArray: [],
        mode: 1,
        assign: 0,
        qualified: null,
        userid: 0,
        time: '',
        courseList: [],
        paperList: [],
        researchList: [],
        trainList: [],
        studyStageForm: [{
          xuhao: 1,
          count: 0,
          studyStageItemForm: []
        }]
      },
      row: {},
      num: 0,
      count: 1,
      // 课程数据
      course: {
        searchForm: {
          oneid: null,
          twoid: null,
          search: ''
        },
        currentPage: 1,
        pageSize: 10,
        total: 0,
        twokey: '',
        loading: false,
        courseVisible: false,
        courseClass: [],
        twoClass: [],
        kcglcourseData: [],
        sort: 0
      },
      // 试卷数据
      paper: {
        searchForm: {
          name: ''
        },
        paperList: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        paperVisible: false,
        paperLoading: false
      },
      // 问卷数据
      research: {
        searchForm: {
          title: ''
        },
        researchList: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        researchVisible: false
      },
      // 线下培训数据
      train: {
        searchForm: {
          name: ''
        },
        trainList: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        trainVisible: false
      },
      // 详情数据
      showVisible: false,
      showStudyList: [],
      studyRecordList: [],
      recordVisible: false,
      showTotal: 0,
      showPageSize: 10,
      showCurrentPage: 1,
      showForm: {
        name: ''
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getDealerList()
    this.getKcglCourseData()
    this.getCourseClassData()
    this.getPaperData()
    this.getResearchData()
    this.getTrainData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    showSearch() {
      this.showCurrentPage = 1
      this.showStudy(this.row)
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        name: this.searchForm.name,
        delid: this.user.delid
      }
      getDealerStudyListGxj(data).then(response => {
        this.studyList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getDealerList() {
      selectDealerList({ delid: this.user.delid }).then(response => {
        this.dealerList = response.data
      }).catch(() => {})
    },
    addStudyTem() {
      this.count = 0
      this.addForm.timeType = 0
      this.addForm.stid = 0
      this.addForm.name = ''
      this.addForm.mode = 1
      this.addForm.timeArray = []
      this.addForm.assign = 0
      this.addForm.qualified = null
      this.addForm.studyStageForm = []
      this.addForm.dealerIdList = []
      this.addStage()
      this.dialogTitle = '添加学习任务'
      this.dialogVisible = true
    },
    submitTem() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            if (this.addForm.timeType === 1) {
              if (this.addForm.timeArray === null || this.addForm.timeArray.length === 0) {
                this.$message.error('请选择有效期')
                return
              }
            }
            for (const stage of this.addForm.studyStageForm) {
              if (stage.studyStageItemForm.length === 0) {
                this.$message.error('阶段任务中请至少添加一个学习内容')
                return
              }
            }
            const dealerIds = []
            for (const id of this.addForm.dealerIdList) {
              if (this.addForm.assign === 2) {
                dealerIds.push(id)
              }
            }
            this.btnLoading = true
            let startTime = 0
            let endTime = 0
            if (this.addForm.timeType === 0) {
              this.addForm.timeArray = []
              startTime = 0
              endTime = 0
            } else {
              startTime = this.addForm.timeArray[0]
              endTime = this.addForm.timeArray[1]
            }
            const _studyStageForm = []
            for (const s of this.addForm.studyStageForm) {
              _studyStageForm.push({
                xuhao: s.xuhao,
                name: s.name,
                studyStageItemForm: s.studyStageItemForm
              })
            }
            const data = {
              stid: this.addForm.stid,
              name: this.addForm.name,
              starttime: startTime,
              endtime: endTime,
              mode: this.addForm.mode,
              assign: this.addForm.assign,
              qualified: this.addForm.qualified,
              userid: this.user.userid,
              delid: this.user.delid,
              dealerIds: dealerIds.join(','),
              studyStageForm: qs.parse(_studyStageForm)
            }
            addOrEditDealerStudyGxj(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    editStudyTem(row) {
      this.addForm.timeArray = []
      if (row.starttime !== '0' && row.endtime !== '0') {
        let time_SE = []
        this.addForm.timeType = 1
        time_SE.push(row.starttime) // 有效期起
        time_SE.push(row.endtime) // 有效期止
        this.addForm.timeArray = time_SE
      } else {
        this.addForm.timeType = 0
        this.addForm.timeArray = []
      }
      this.addForm.stid = row.stid
      this.addForm.name = row.name
      this.addForm.mode = row.mode
      this.addForm.assign = row.assign
      this.addForm.qualified = row.qualified
      this.addForm.studyStageForm = []
      getStudyStageById({ stid: row.stid }).then(response => {
        let index = 0
        this.count = response.data.length
        for (const stage of response.data) {
          this.addForm.studyStageForm.push({
            count: 0,
            xuhao: stage.xuhao,
            name: stage.name,
            studyStageItemForm: []
          })
          for (const item of stage.itemList) {
            this.addForm.studyStageForm[index].studyStageItemForm.push({
              father: index,
              xuhao: item.xuhao,
              type: item.type,
              dataid: item.dataid,
              name: item.study_name
            })
            this.addForm.studyStageForm[index].count++
          }
          index++
        }
        this.count = index
      })
      if (row.assign === 2) {
        const data = {
          stid: row.stid
        }
        getDealerStudyAssignData(data).then(response => {
          this.addForm.dealerIdList = response.data
          this.dialogLoading = false
        })
      }
      this.dialogTitle = '修改学习任务'
      this.dialogVisible = true
    },
    deleteStudyTem(row) {
      this.$confirm('您确定要删除此学习吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteStudyGxj({ stid: row.stid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    showStudy(row) {
      this.showForm = []
      this.showStudyList = []
      const data = {
        name: this.showForm.name,
        stid: row.stid,
        page: this.showCurrentPage,
        limit: this.showPageSize
      }
      getShowStudyList(data).then(response => {
        this.showStudyList = response.data
        this.showTotal = response.total
      })
      this.showVisible = true
    },
    showStudyRecord(row) {
      this.studyRecordList = []
      const data = {
        said: row.said,
        stid: row.stid
      }
      getStudyRecordList(data).then(response => {
        this.studyRecordList = response.data
      })
      this.recordVisible = true
    },
    addStage() {
      this.addForm.studyStageForm.push({
        xuhao: this.count + 1,
        name: '',
        studyStageItemForm: [],
        count: 1
      })
      this.count++
    },
    deleteStage(index) {
      if (index === 0) {
        this.$message.error('请至少保留一个阶段哦')
      } else {
        this.$confirm('您确定要删除此阶段吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          this.addForm.studyStageForm.splice(index, 1)
          this.count--
          let xuhao = 1
          for (const stage of this.addForm.studyStageForm) {
            stage.xuhao = xuhao
            xuhao++
          }
        }).catch(() => {
        })
      }
    },
    deleteStageItem(index, index2) {
      if (index2 !== -1) {
        this.addForm.studyStageForm[index].studyStageItemForm.splice(index2, 1)
        this.addForm.studyStageForm[index].count--
      }
      let xuhao = 1
      for (const item of this.addForm.studyStageForm[index].studyStageItemForm) {
        item.xuhao = xuhao
        xuhao++
      }
    },
    addCourse(index) {
      for (const course of this.addForm.courseList) {
        this.addForm.studyStageForm[index].studyStageItemForm.push({
          father: index,
          xuhao: this.addForm.studyStageForm[index].count + 1,
          type: 1,
          name: course.cname,
          dataid: course.cid
        })
        this.addForm.studyStageForm[index].count++
      }
      this.course.courseVisible = false
      this.addForm.courseList = []
    },
    addPaper(index) {
      for (const paper of this.addForm.paperList) {
        this.addForm.studyStageForm[index].studyStageItemForm.push({
          father: index,
          xuhao: this.addForm.studyStageForm[index].count + 1,
          name: paper.dName,
          type: 2,
          dataid: paper.dPaperid
        })
        this.addForm.studyStageForm[index].count++
      }
      this.paper.paperVisible = false
      this.addForm.paperList = []
    },
    addResearch(index) {
      for (const research of this.addForm.researchList) {
        this.addForm.studyStageForm[index].studyStageItemForm.push({
          father: index,
          xuhao: this.addForm.studyStageForm[index].count + 1,
          type: 3,
          name: research.title,
          dataid: research.rid
        })
        this.addForm.studyStageForm[index].count++
      }
      this.research.researchVisible = false
      this.addForm.researchList = []
    },
    addTrain(index) {
      for (const train of this.addForm.trainList) {
        this.addForm.studyStageForm[index].studyStageItemForm.push({
          father: index,
          xuhao: this.addForm.studyStageForm[index].count + 1,
          type: 4,
          name: train.dName,
          dataid: train.dTid
        })
        this.addForm.studyStageForm[index].count++
      }
      this.train.trainVisible = false
      this.addForm.trainList = []
    },
    showHandleSizeChange(val) {
      this.showPageSize = val
      this.showCurrentPage = 1
      this.showStudy(this.row)
    },
    showHandleCurrentChange(val) {
      this.showCurrentPage = val
      this.showStudy(this.row)
    },
    // 课程方法
    getTwoClass() {
      this.course.searchForm.twoid = null
      if (this.course.searchForm.oneid !== '' && this.course.searchForm.oneid !== null && this.course.searchForm.oneid !== undefined) {
        for (const d of this.course.courseClass) {
          if (d.dOneid === this.course.searchForm.oneid) {
            this.course.twoClass = d.twoList
            break
          }
        }
      } else {
        this.course.twoClass = []
      }
      this.course.twokey = new Date().getTime().toString()
    },
    courseSearch() {
      this.course.currentPage = 1
      this.getKcglCourseData()
    },
    getCourseClassData() {
      getCourseClass().then(response => {
        this.course.courseClass = response.data
      })
    },
    getKcglCourseData() {
      this.course.loading = true
      const data = {
        page: this.course.currentPage,
        limit: this.course.pageSize,
        content: this.course.searchForm.search,
        twoid: this.course.searchForm.twoid,
        oneid: this.course.searchForm.oneid,
        sort: this.course.sort
      }
      getCourseList(data).then(response => {
        this.course.kcglcourseData = response.data
        this.course.total = response.total
        this.course.loading = false
      }).catch(() => {
        this.course.loading = false
      })
    },
    courseHandleSizeChange(val) {
      this.course.pageSize = val
      this.getKcglCourseData()
    },
    courseHandleCurrentChange(val) {
      this.course.currentPage = val
      this.getKcglCourseData()
    },
    courseSelect(val) {
      this.addForm.courseList = val
    },
    // 试卷方法
    getPaperData() {
      this.paper.loading = true
      this.paper.paperList = []
      const data = {
        page: this.paper.currentPage,
        limit: this.paper.pageSize,
        delid: this.user.delid,
        name: this.paper.searchForm.name
      }
      getDealerPapers(data).then(response => {
        this.paper.paperList = response.data
        this.paper.total = response.total
        this.paper.loading = false
      }).catch(() => {
        this.paper.loading = false
      })
    },
    paperSearch() {
      this.paper.currentPage = 1
      this.getPaperData()
    },
    paperHandleSizeChange(val) {
      this.paperPageSize = val
      this.paperCurrentPage = 1
      this.getPaperData()
    },
    paperHandleCurrentChange(val) {
      this.paperCurrentPage = val
      this.getPaperData()
    },
    paperSelect(val) {
      this.addForm.paperList = val
    },
    // 问卷方法
    getResearchData() {
      this.research.loading = true
      this.research.researchList = []
      const data = {
        page: this.research.currentPage,
        limit: this.research.pageSize,
        delid: this.user.delid,
        title: this.research.searchForm.title
      }
      getDealerResearchList(data).then(response => {
        this.research.researchList = response.data
        this.research.total = response.total
        this.research.loading = false
      }).catch(() => {
        this.research.loading = false
      })
    },
    researchSearch() {
      this.research.currentPage = 1
      this.getResearchData()
    },
    researchHandleSizeChange(val) {
      this.research.pageSize = val
      this.research.currentPage = 1
      this.getResearchData()
    },
    researchHandleCurrentChange(val) {
      this.research.currentPage = val
      this.getResearchData()
    },
    researchSelect(val) {
      this.addForm.researchList = val
    },
    // 线下培训方法
    getTrainData() {
      this.train.loading = true
      this.train.trainList = []
      const data = {
        page: this.train.currentPage,
        limit: this.train.pageSize,
        delid: this.user.delid,
        name: this.train.searchForm.name
      }
      getDealerTrainListGxj(data).then(response => {
        this.train.trainList = response.data
        this.train.total = response.total
        this.train.loading = false
      }).catch(() => {
        this.train.loading = false
      })
    },
    trainSearch() {
      this.research.currentPage = 1
      this.getTrainData()
    },
    trainHandleSizeChange(val) {
      this.train.pageSize = val
      this.train.currentPage = 1
      this.getTrainData()
    },
    trainHandleCurrentChange(val) {
      this.train.currentPage = val
      this.getTrainData()
    },
    trainSelect(val) {
      this.addForm.trainList = val
    },
    handleDraggableFormItemChange(e) {
      let index = 1
      const _itemForm = []
      for (const item of this.addForm.studyStageForm[e.moved.element.father].studyStageItemForm) {
        _itemForm.push({
          father: item.father,
          xuhao: index,
          dataid: item.dataid,
          type: item.type,
          name: item.name
        })
        index++
      }
      this.addForm.studyStageForm[e.moved.element.father].studyStageItemForm = _itemForm
    }
  }
}
</script>

<style scoped>

</style>
